import "vite/modulepreload-polyfill";
import React from "react";
import ReactDOM from "react-dom/client";

import "./assets/scss/base.scss";
import App from "./App";
import { useAppStore } from "./stores/AppStore";
import { PosthogWrapper } from "./components/PosthogWrapper"; // ✅ New wrapper

const appStore = useAppStore.getState();
appStore.cacheVersionValidation();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<PosthogWrapper>
		<App />
	</PosthogWrapper>
);
